/**
 * @see `craft/templates/shop/_includes/addresses/form.html`
 * @author Craft Commerce
 */
(function() {

	/**
	 * 1. The known states have been stored in the states `select`
	 *    as data-attribute.
	 */
	var params = {
		states: $('select.address-stateId').data('known-states'), /* [1] */
	};

	//	======================================================================  //
	//	Default craft logic
	//	======================================================================  //

	/**
	 * @function `basedigitalChangeLabelForAttribute`
	 *
	 * Changes the `for` attribute of the "State" field label according to
	 * the `id` of the form input shown on the front-end: either a select (if
	 * states are known for the selected country) or a regular text field.
	 *
	 * 1. Craft variables, left untouched.
	 * 2. Quick escape that prevents error from occurring on pages other than
	 *    the one we target.
	 */
	function basedigitalChangeLabelForAttribute( statesParam ) {

		var $stateLabel = $('#js-state-label');
		var $country = $('select.address-country');

		var craftVars = { /* [1] */
			cid: $country.val(),
			$states: $country.closest('.addressBox').find('select.address-stateId'),
			$stateName: $country.closest('.addressBox')
				.find('input.address-stateName')
		};

		if( !$stateLabel.length ) { /* [2] */
			return;
		}

		if( statesParam.hasOwnProperty(craftVars.cid) ) {
			$stateLabel.attr('for', craftVars.$states.attr('id'));
		}
		else {
			$stateLabel.attr('for', craftVars.$stateName.attr('id'));
		}
	}

	/**
	 * @function `craftCommerceStateLogic`
	 *
	 * The original country state logic to show/hide the states `select` if states
	 * are known for the selected country.
	 *
	 * @param statesParam (obj) - a JSON object
	 *
	 * 1. Originally `{{ craft.commerce.statesArray|json_encode|raw }}` but as the
	 *    script is separated from the template, we can't get the states this way.
	 * 2. Base Digital customization.
	 */
	function craftCommerceStateLogic( statesParam ) {
		var states = statesParam; /* [1] */

		$('select.address-country').change(function ()
		{
			// get the value of the selected country.
			var cid = $(this).val();
			var $states = $(this).closest('.addressBox')
				.find('select.address-stateId');
			var $stateName = $(this).closest('.addressBox')
				.find('input.address-stateName');
			$states.find('option').remove();

			if (states.hasOwnProperty(cid))
			{
				// We have states for this country, show the states drop down.
				$states.removeClass('hidden');
				$states.attr('name', $states.data('modelname')+'[stateValue]');

				// We have states for this country, hide the stateName input.
				$stateName.removeAttr('name');
				$stateName.addClass('hidden');
				$stateName.val('');

				// Add all states as options to drop down.
				for (var id in states[cid])
				{
					var state = states[cid][id];
					var $option = $('<option/>');
					$option.attr('value', id).text(state);
					$states.append($option);
				}

			}else{
				// hide the states dropdown, since this country has none.
				$states.addClass('hidden');
				$states.removeAttr('name');

				// show the stateName
				$stateName.removeClass('hidden');
				$stateName.attr('name', $stateName.data('modelname')+'[stateValue]');
			}

			/* NOTE: only addition to the original Craft Commerce logic */
			basedigitalChangeLabelForAttribute( states ); /* [2] */

		});

		$('select').addClass('input-sm');
	}

	//	======================================================================  //
	//	On ready
	//	======================================================================  //

	onReady.callbacks.checkoutStates = function() {
		craftCommerceStateLogic( params.states );
		basedigitalChangeLabelForAttribute( params.states );
	};

})();
